import {Component, OnInit, signal} from '@angular/core';
import {RouterOutlet} from '@angular/router';
import {CommonModule} from '@angular/common';
import {MsalService} from '@azure/msal-angular';
import {EventMessage, EventType, InteractionRequiredAuthError} from '@azure/msal-browser';
import {Subject} from 'rxjs';
import {UserService} from '@services/user.service';
import {HttpClient} from '@angular/common/http';
import {OdooService} from '@services/odoo.service';
import {environment} from '@env/environment'
import {ApiService} from '@services/api.service';
import {RequestFormComponent} from '@components/request-form/request-form.component';
import {SidemenuComponent} from '@components/sidemenu/sidemenu.component';
import {MyRequestsComponent} from '@components/my-requests/my-requests.component';
import {RequestComponent} from '@components/request/request.component';
import {ProceduresComponent} from '@components/procedures/procedures.component';
import {ProcedureComponent} from '@components/procedure/procedure.component';
import {ImsComponent} from '@components/ims/ims.component';

export interface ClickedItem {
  type: string;
  item: any;
}

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, CommonModule, RequestFormComponent, SidemenuComponent, MyRequestsComponent, RequestComponent, ProceduresComponent, ProcedureComponent, ImsComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent implements OnInit {
  title = 'hr_forms';

  isLoggedIn = false;
  private readonly _destroying$ = new Subject<void>()

  constructor(
    public msalService: MsalService,
    private userService: UserService,
    private odooService: OdooService,
    private http: HttpClient,
    private api: ApiService
  ) {
  }

  menuOpen = signal(false)
  currentPage = signal("my-requests");
  selectedItem = signal<ClickedItem | null>(null);

  onNavigate(page: string) {
    if (page === 'close') {
      this.menuOpen.set(false);
    } else {
      console.log(page)
      this.currentPage.set(page);
      this.menuOpen.set(false)
      this.selectedItem.set(null);
    }
  }

  onRowSelected(event: any) {
    if (event && event.item.data) {
      let clickedItem: ClickedItem = {type: event.type, item: event.item.data};
      this.selectedItem.set(clickedItem)
    } else {
      console.error("unable to retrieve selected item");
    }
  }

  goBack() {
    this.selectedItem.set(null);
  }

  toggleMenu(type: string) {
    if (type === 'menu') {
      this.menuOpen.update(value => !value);
    }
  }

  async ngOnInit(): Promise<void> {

    await this.msalService.initialize().subscribe((result) => {
      this.msalService.instance.handleRedirectPromise().then(authResult => {
        if (authResult) {
          console.log(authResult)
          this.msalService.instance.setActiveAccount(authResult.account)
          this.userService.setUsername(authResult.account)
          this.odooAuth().subscribe({
            next: (response: any) => {
              this.odooService.setSessionId(response.result.sessionId)
            },
            complete: () => {
              this.checkLoginStatus();
            }
          });

        } else if (this.msalService.instance.getActiveAccount() != null) {
          this.userService.setUsername(this.msalService.instance.getActiveAccount())
          this.odooAuth().subscribe({
            next: (response: any) => {
              this.odooService.setSessionId(response.result.sessionId)
            },
            complete: () => {
              this.checkLoginStatus();
            }
          });
        } else {
          this.userService.clearUsername();
        }

      }).catch(error => {
        console.error(error);
      })

      this.msalService.instance.addEventCallback((event: EventMessage) => {
        if (event.eventType === EventType.LOGIN_FAILURE) {
          if (event.error instanceof InteractionRequiredAuthError) {
            this.checkLoginStatus()
            this.msalService.loginRedirect();
            this.userService.clearUsername();
          }
        }
      });
    });
  }

  checkLoginStatus() {
    this.isLoggedIn = this.msalService.instance.getActiveAccount() != null && this.odooService.getSessionId() != null;
  }

  loginRedirect(): void {
    this.msalService.loginRedirect();
  }

  ngOnDestroy() {
    this._destroying$.next(undefined);
    this._destroying$.complete();
  }

  odooAuth() {
    return this.api.login(environment.odoo.login, environment.odoo.password);
  }
}
